export default __webpack_public_path__ + "static/media/solutions-4k.11d7c8b2.jpg";